import { observable, action, computed } from 'mobx';
import { arrDiff } from '../utils/util';
import commentApi from '../actions/comment';
import RootStore from './RootStore';
import { IResult } from '../global';

export default class CommentStore {
  @observable commentList = [] as any;
  @observable commentTop = [];
  @observable topCommentList = [];
  @observable total = 0; // 这个总数是评论的总数，不包括置顶评论，总的评论数请采用 sumTotal
  @observable lastTime = Number.MAX_SAFE_INTEGER;
  @observable minCreateTime = new Date().getTime(); // 最小的创建时间，注意，加载更多是加载老的评论，而默认的刷新是加载最新的评论
  @observable commentLoadAll = false; //评论是否已经加载完
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
  // 总的评论数
  @computed get sumTotal() {
    return this.total + this.topCommentList.length;
  }
  @action addOne(one: any) {
    this.commentList = [one, ...this.commentList];
    this.total = Number(this.total) + 1;
  }
  @action deleteOneById = (id: number) => {
    if (!id) {
      return;
    }
    const index = this.commentList.findIndex((one: any) => one.id == id);
    if (index !== -1) {
      this.commentList = [
        ...this.commentList.slice(0, index),
        ...this.commentList.slice(index + 1)
      ];

      this.total = Math.max(0, Number(this.total) - 1);
    }
  };
  getTop(galleryId: string) {
    return commentApi.top(galleryId).then(
      action((jsonData: IResult) => {
        if (jsonData && jsonData.data) {
          this.topCommentList = jsonData.data;
          return this.topCommentList;
        }
      })
    );
  }
  getList(galleryId: string) {
    return commentApi.list(galleryId, this.lastTime).then(
      action((jsonData: IResult) => {
        if (jsonData && jsonData.data) {
          const theData = jsonData.data as any[];
          const sublength = theData.length;
          const { total } = jsonData;
          this.total = total;
          // console.log(total);
          //现在有前端的前置评论了，必须得考虑去重问题
          this.commentList = [
            ...arrDiff(
              this.commentList.slice(),
              theData,
              (a1: any, a2: any) => {
                return a1.id === a2.id;
              }
            ),
            ...(jsonData.data as any)
          ] as any;
          const { length } = this.commentList;
          // 认定如果返回的数量是0 或者返回的数量和 commentList一样 说明已经加载完所有评论
          // （不考虑后来新增的评论，反正不定期的在刷新评论）
          if (length === total || sublength < 50) {
            this.commentLoadAll = true;
          }
          if (length) {
            // this.lastTime = this.commentList[0].createtime || 0;
            this.minCreateTime = (this.commentList[
              length - 1
            ] as any).createtime;
            this.lastTime = (this.commentList[length - 1] as any).createtime;
          }
          //console.log(this.commentList.slice())
          return this.commentList;
        }
      })
    );
  }
  @action clear() {
    this.lastTime = Number.MAX_SAFE_INTEGER;
    this.commentList = [];
  }
}
